import "@/lib/firebase";

import { getAuth, signOut as firebaseSignOut } from "firebase/auth";

import {
  createCredentialFromIdToken,
  getIdToken,
  getUser,
  register,
  signIn,
  signInWithCredential,
  signInWithCustomToken,
} from "@/lib/firebase-auth";
import { clearNurseryContextCache } from "@/lib/offline/db";

// Re-export Firebase auth utilities
export {
  createCredentialFromIdToken,
  getIdToken,
  getUser,
  register,
  signIn,
  signInWithCredential,
  signInWithCustomToken,
};

/**
 * Sign out the current user from Firebase Auth.
 * This will trigger the onAuthStateChanged listener in AuthContext.
 */
export async function signOut(): Promise<void> {
  const auth = getAuth();
  // Drop the cached organisation/nursery context first. Both cache rows are keyed
  // by a fixed string rather than by user, so leaving them behind lets the next
  // account to sign in on this device inherit this user's active organisation and
  // selected nursery.
  await clearNurseryContextCache();
  await firebaseSignOut(auth);
}

/**
 * Get the current Firebase user synchronously.
 * Returns null if no user is signed in.
 */
export function getCurrentUser() {
  return getUser();
}

/**
 * Check if a user is currently signed in.
 */
export function isAuthenticated(): boolean {
  return !!getUser();
}

/**
 * Get the current user's ID token.
 * Returns undefined if no user is signed in.
 */
export async function getCurrentIdToken(): Promise<string | undefined> {
  return getIdToken();
}
